import { Modal } from "@twinkltech/curriculum-architect-component-library";
import { useTwinklAnalytics } from "@twinkltech/web-analytics-ts";
import { Button, Text } from "@twinkltech/web-ui";
import { useId, useState } from "react";
import { useTranslation } from "react-i18next";

import { COMMON_NS } from "@/i18n/common/common.i18n";

import { REMOVE_UNIT_MODAL_NS } from "./RemoveUnitModal.i18n";

export const RemoveUnitModal = ({
  cellId,
  onClose,
  onSubmit,
  unit,
}: {
  cellId: string;
  onClose: () => void;
  onSubmit: (params: { cellId: string }) => void;
  unit: {
    title: string;
    startOnColumn: string;
    endOnColumn?: string;
    cohort: string;
  };
  resource?: {
    title: string;
  };
}) => {
  const { t } = useTranslation(REMOVE_UNIT_MODAL_NS);

  const { click } = useTwinklAnalytics();

  const [isSubmitting, setIsSubmitting] = useState(false);

  // Accessibility IDs
  const formId = useId();

  const onHandleOnClose = () => {
    click("click_cta", {
      ctaCopy: "Proceed and Remove Unit",
      clickLocation: "Remove Unit Modal",
    });
    onClose();
  };

  const onFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!onSubmit || isSubmitting) {
      return;
    }

    setIsSubmitting(true);
    onSubmit({
      cellId,
    });
    setIsSubmitting(false);
    onHandleOnClose();
  };

  return (
    <Modal hasCloseButton open width="md" onClose={onHandleOnClose}>
      <Modal.Header className="pb-0!">
        <Modal.Title>Remove unit from Planner</Modal.Title>
        <Text className="mt-3">{t("confirm-message")}</Text>
      </Modal.Header>
      <Modal.Body className="mb-2 max-h-[80vh] mt-12">
        <form
          className="flex flex-col gap-0 text-center"
          id={formId}
          onSubmit={onFormSubmit}
        >
          <Text className="mt-0! mb-8!" variant="2xl-medium">
            {t("confirm-sub-title")}
          </Text>

          <Text className="m-3!" variant="xl-medium">
            {unit.title}
          </Text>
          <Text className="m-0!" variant="xl-normal">
            {unit.cohort}
          </Text>
          <Text className="m-0!" variant="xl-normal">
            {unit.startOnColumn === unit.endOnColumn
              ? unit.startOnColumn
              : `${unit.startOnColumn} - ${unit.endOnColumn}`}
          </Text>
        </form>
      </Modal.Body>
      <Modal.Footer className="gap-3">
        <Button type="button" variant="outlined" onClick={onHandleOnClose}>
          {t("actions.cancel", { ns: COMMON_NS })}
        </Button>
        <Button disabled={isSubmitting} form={formId} variant="error">
          {t("save")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
